import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface LogistikState extends BasePageState {}
interface LogistikModel {}

export default class LogistikPage extends Basepage<
  LogistikState,
  LogistikModel
> {
  renderChild(): JSX.Element {
    return <div id="logistik">Logistik</div>;
  }
  initState(base: BasePageState): LogistikState {
    let newState: LogistikState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Logistik';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Logistik</span>;
  }
  getType(): string {
    return 'LogistikPage';
  }
}
